<template>
  <div class="py-3" style="background-color: white">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center pb-3 px-5" style="border-bottom:#D6D5D5 solid 1px">
      <h1 class="mb-0" style="font-size:16px;font-weight:500">Danh sách lỗi</h1>
      <div class="d-flex align-items-center gap-2">
        <button type="button" class="btn btn-primary mr-2" @click="exportErrorList()" :disabled="exportLoading"><i
            class="fa fa-upload mr-1"></i><i class="el-icon-loading" v-if="exportLoading"></i> Export
        </button>
      </div>
    </div>
    <!--    body-->
    <div class="px-5">
      <!-- Filters -->
      <div class="row flex-wrap mb-3 mt-3 gap-3">
        <div class="col-lg-2 mb-2">
          <p>Mã lỗi</p>
          <el-input placeholder="Nhập mã lỗi" v-model="filter.code" size="medium"><i slot="suffix"
                                                                                     class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="col-lg-2 mb-2">
          <p>Danh mục</p>
          <el-select v-model="filter.type" placeholder="Chọn danh mục" size="medium" style="width:100%" clearable>
            <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-2 mb-2">
          <p>Nhóm giảng viên</p>
          <el-select v-model="filter.groupLecturer" placeholder="Chọn nhóm giảng viên" size="medium" style="width:100%"
                     filterable clearable>
            <el-option
                v-for="item in groupLecturerList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-2 mb-2">
          <p>Giảng viên</p>
          <el-select v-model="filter.lecturer" placeholder="Chọn giảng viên" size="medium" style="width:100%"
                     filterable clearable>
            <el-option
                v-for="item in lecturerList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-2 mb-2">
          <p>Trạng thái</p>
          <el-select v-model="filter.status" placeholder="Chọn trạng thái" size="medium" style="width:100%" filterable
                     clearable>
            <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-3 mb-2">
          <p>Thời gian tạo</p>
          <el-date-picker
              v-model="filter.createdTime"
              type="daterange"
              range-separator="-"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              clearable
          >
          </el-date-picker>
        </div>
        <div class="col-lg-3 mb-2">
          <p style="color: white">Tìm kiếm</p>
          <button type="button" class="btn btn-primary" @click="getApiErrorList()"><i slot="suffix"
                                                                                      class="el-input__icon el-icon-search"></i>Tìm
            kiếm
          </button>
        </div>
      </div>
      <!-- Table -->
      <div class="table-responsive" style="max-height: 500px">
        <table class="table table-bordered table-hover text-nowrap">
          <thead class="thead-light ">
          <tr>
            <th>Mã lỗi</th>
            <th>Chỉ số gặp vấn đề</th>
            <th>Đối tượng đo lường</th>
            <th>Trạng thái</th>
            <th>Nhóm giảng viên</th>
            <th>Deadline xử lý</th>
            <th>Thời gian tạo</th>
            <th>Hành động</th>
          </tr>
          </thead>
          <tbody v-if="tableLoading">
          <tr>
            <td colspan="8" style="text-align: center"><i class="el-icon-loading"></i></td>
          </tr>
          </tbody>
          <tbody v-else-if="errorList.length === 0">
          <tr>
            <td colspan="8" style="text-align: center"><span>Không có dữ liệu</span></td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr v-for="item in errorList" :key="item.id">
            <td>{{ item.errorCode }}</td>
            <td>{{ item.indicator }}</td>
            <td>{{ item.target }}</td>
            <td><span class="badge text-dark" :class="statusMap[item.status]?.class">{{
                statusMap[item.status]?.label
              }}</span></td>
            <td>{{ item.teacherGroup }}</td>
            <td>{{ item.deadline }}</td>
            <td>{{ item.createdAt }}</td>
            <td>
              <router-link :to="{name:'radar-error-detail',params:{id:item.errorCode}}"
                           class="btn btn-xs btn-icon btn-outline-primary mr-2" title="Chi tiết"><i
                  class="fa fa-eye"></i></router-link>
              <button class="btn btn-xs btn-icon btn-outline-danger" v-if="item.status === statusList[0].value"
                      @click="deleteError(item.errorCode)" title="Hủy lỗi"><i class="fas fa-trash"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <!-- Pagination -->
      <div class="edu-paginate mx-auto text-center d-flex justify-content-between mt-10">
        <div class="spacer"></div>
        <paginate
            v-model="page"
            :page-count="lastPage"
            :page-range="3"
            :margin-pages="1"
            :click-handler="clickPage"
            :prev-text="'Trước'"
            :next-text="'Sau'"
            :container-class="'pagination b-pagination'"
            :pageLinkClass="'page-link'"
            :next-link-class="'next-link-item'"
            :prev-link-class="'prev-link-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :page-class="'page-item'"
        />
        <div class="right-div mr-10">Tổng số bản ghi: <span style="color:#0066FF">{{ total }}</span></div>
      </div>

    </div>
    <DeleteErrorModal :currentError="currentError" @getListError="getApiErrorList"></DeleteErrorModal>
  </div>

</template>
<script>
import DeleteErrorModal from "./DeleteErrorModal.vue";
import {
  EXPORT_ERROR_LIST_LEADER_RADAR,
  GET_GROUP_LECTURER_LIST, GET_LECTURER_LIST,
  TEACHER_ERROR_LIST
} from "../../../../core/services/store/report-error/reportError.module";
import {exportExcel, formatDate, formatDateTime} from "../../../../core/filters";
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";

export default {
  name: "ErrorList",
  components: {DeleteErrorModal},
  data() {
    return {
      filter: {
        code: '',
        type: null,
        groupLecturer: null,
        lecturer: null,
        status: null,
        createdTime: []
      },
      typeList: [],
      groupLecturerList: [],
      lecturerList: [],
      statusList: [
        {value: 0, label: 'Cần xử lý'},
        {value: 1, label: 'Đã xử lý'},
        {value: 2, label: 'Hoàn thành'},
        {value: 3, label: 'Hủy'}
      ],
      statusMap: {
        0: {label: 'Cần xử lý', class: 'badge badge-warning text-dark'},
        1: {label: 'Đã xử lý', class: 'badge badge-primary'},
        2: {label: 'Hoàn thành', class: 'badge badge-success'},
        3: {label: 'Hủy', class: 'badge badge-secondary'}
      },
      errorList: [],
      tableLoading: false,
      page: 1,
      lastPage: 1,
      total: 0,
      currentError: null,
      exportLoading: false
    }
  },
  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý giảng viên", route: ""},
      {title: "Danh sách lỗi"},
    ]);
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      await this.getApiErrorList()
      await this.getApiTypeList()
      await this.getApiGroupLecturerList()
      await this.getApiLecturerList()
    } catch (e) {

    } finally {
      loading.close();
    }

  },
  methods: {
    async getApiTypeList() {
      this.typeList = [
        {value: 1, label: 'Tỉ lệ đạt năng lực'},
        {value: 2, label: 'Tỉ lệ lỗi giảng dạy'},
        {value: 4, label: 'Tỉ lệ pass Final lần 1'},
        {value: 3, label: 'Tỉ lệ pass Midterm'},
      ]
    },
    async getApiGroupLecturerList() {
      try {
        const res = await this.$store.dispatch(GET_GROUP_LECTURER_LIST)
        this.groupLecturerList = res?.data.map((groupLecturer) => ({
          value: groupLecturer.id,
          label: groupLecturer.name
        }))
      } catch (e) {

      }

    },
    async getApiLecturerList() {
      try {
        const res = await this.$store.dispatch(GET_LECTURER_LIST)
        this.lecturerList = res?.data.map((lecture) => ({value: lecture.id, label: lecture.name}))
      } catch (e) {

      }

    },
    async getApiErrorList(page = 1) {
      this.tableLoading = true
      try {
        let filter = {
          code: this.filter.code,
          metric_type: this.filter.type,
          group_teacher_id: this.filter.groupLecturer,
          teacher_id: this.filter.lecturer,
          status: this.filter.status,
          created_at: this.filter.createdTime,
          page: page
        }
        const response = await this.$store.dispatch(TEACHER_ERROR_LIST, filter)
        this.errorList = response.data.map((error) => ({
          id: error?.id,
          errorCode: error?.id,
          indicator: error?.metric_label,
          target: `${error.teacher_id ? error.teacher_id + 100000 : ''} - ${error.teacher_name ? error.teacher_name : ''}`,
          status: error?.status,
          teacherGroup: error?.teacher_group_name,
          deadline: formatDate(error?.deadline_at),
          createdAt: formatDateTime(error?.created_at)
        }))
        let pagination = response.pagination
        this.total = pagination?.total
        this.lastPage = pagination?.last_page
        this.page = pagination?.current_page
      } catch (e) {

      } finally {
        this.tableLoading = false
      }
    },
    clickPage(p) {
      this.page = p
      this.getApiErrorList(p)
    },
    deleteError(idError) {
      this.currentError = idError
      this.$nextTick(() => {
        this.$bvModal.show('delete-error-modal')
      })

    },
    showDetail(item) {
      this.$router.push({name: 'radar-error-detail', params: {id: item.errorCode}})
    },
    async exportErrorList() {
      try {
        this.exportLoading = true
        const filter = {
          code: this.filter.code,
          metric_type: this.filter.type,
          group_teacher_id: this.filter.groupLecturer,
          teacher_id: this.filter.lecturer,
          status: this.filter.status,
          created_at: this.filter.createdTime,
        }
        const res = await this.$store.dispatch(EXPORT_ERROR_LIST_LEADER_RADAR, filter)
        const HEADER_ROW_EXPORT_ERROR_DETAIL = [
          {key: 'Mã lỗi', value: 'Mã lỗi'},
          {key: 'Loại chỉ số', value: 'Loại chỉ số'},
          {key: 'Giảng viên', value: 'Giảng viên'},
          {key: 'Nhóm giảng viên', value: 'Nhóm giảng viên'},
          {key: 'Trạng thái', value: 'Trạng thái'},
          {key: 'Ngày tạo', value: 'Ngày tạo'},
          {key: 'Hạn xử lý', value: 'Hạn xử lý'},
        ]
        const data = res.data.map((error) => {
          return error.reduce((acc, item) => {
            acc[item.key] = item.value
            return acc
          }, {})
        })
        exportExcel(HEADER_ROW_EXPORT_ERROR_DETAIL, data, 'Danh sách lỗi.xlsx', false)

      } catch (e) {
        this.$message.error('Export thất bại');
      } finally {
        this.exportLoading = false
      }

    }
  }
}
</script>

<style scoped>
.sticky-header th {
  position: sticky;
  top: 0;
  background: #f8f9fa !important;
  z-index: 9;
}
</style>